//Library Imports
import { useHistory, useParams } from "react-router";

// application components goes here
import GlobalStyle from "../../../../GlobalStyle";
import loginbg from "../../../../assets/img/login-bg.png";
import Nav from "./Nav";
import { ReactComponent as Logo } from "../../../../assets/img/Workbench_WhiteLogo.svg";

// styles goes here
import styled from "styled-components";
import SetNewPassword from "./SetNewPassword";

type ResetParams = {
  resetKey: string;
};

const ResetPassword: React.FC = (props) => {
  const history = useHistory();
  const { resetKey } = useParams<ResetParams>();

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <div className="container-fluid" style={{ minHeight: "100vh" }}>
          <Header>
            <div className="row">
              <div className="col-6">
                <Logo />
              </div>
              <div className="col-6 d-flex justify-content-end">
                <Nav />
              </div>
            </div>
          </Header>
          <Content className="d-flex align-items-center">
            <div className="row justify-content-between" style={{ margin: "0 auto", width: "calc(100% - 0px)" }}>
              <div className="col-xl-7 col-lg-6 d-flex align-items-center">
                <Tagline>Helping you nurture today’s conversations, today</Tagline>
              </div>
              <div className="col login-box d-flex justify-content-end">
                <SetNewPassword
                  setRedirectPath={(value: string) => {
                    history.push(value);
                  }}
                  resetKey={resetKey}
                />
              </div>
            </div>
          </Content>
        </div>
      </Wrapper>
    </>
  );
};

export default ResetPassword;

const Wrapper = styled.div`
  background-image: url(${loginbg});
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
`;
const Header = styled.header`
  padding: 80px 75px 100px 75px;
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 40px 75px 0 75px;
  }
  svg {
    height: 30px;
    width: auto;
    margin-top: -15px;
  }
`;
const Content = styled.section`
  padding: 25px 75px 0 75px;
  min-height: calc(100vh - 205px);
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    // padding: 25px 75px 0 75px;
    min-height: calc(100vh - 85px);
  }
  .login-box {
    max-width: 500px;
    margin-right: -12px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      max-width: 450px;
    }
  }
`;
const Tagline = styled.h1`
  padding-left: 60px;
  margin: 0;
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  font-family: 'Roboto Slab', serif;
  @media all and (max-width: 1439px) {
    font-size: 32px;
  }
`;
